$(document).ready(function()
{

	var currentCategory = '';
	var currentStatus = '';
	var totalProjects =  $("#projectListingsContent .project-row").length;
	$('#projectCount').html(totalProjects);
 	var currentProjectCount = 0;

	function projectListings()
	{
        $("input[type=radio][name=cat_choice]").change(function()
        {
            monitorFilterChanges('category', $(this));
        });

        $("input[type=radio][name=status_choice]").change(function()
        {
            monitorFilterChanges('status', $(this));
        });

        function monitorFilterChanges(input_type, el)
        {
            var clickedElement = el; // just clicked
            var val = clickedElement.data("value");
            

            // STEP 1: ASSIGN CONSTANTS
            if (input_type == 'status')
            {
            	currentStatus = ( val == "all" ) ? '' : val;
            }

            if (input_type == 'category')
            {
            	currentCategory = ( val == "all" ) ? '' : val;
            }


            // STEP 2A: OPEN EVETRHING
            if (currentCategory == '' && currentStatus == '')
            {

	  			currentProjectCount = $("#projectListingsContent .project-row").length;	 

	            $("#projectListingsContent .project-header").slideDown( 200 );
	            $("#projectListingsContent .project-row").slideDown( 500 );

	            // outputs
	            $('#projectCount').html(currentProjectCount);
	            $('#noProjects').slideUp( 100 );
         	
            }
            // OR STEP 2B: CLOSE EVERYTHING AND OPEN AGAIN
            else
            {
            	currentProjectCount = 0;
            	var openStatuses = [];
	            $("#projectListingsContent .project-header").slideUp( 100 );
	            $("#projectListingsContent .project-row").slideUp( 100 );


	            if (currentCategory != '' && currentStatus == '')
	            {
	            	
		            $('#projectListingsContent .project-row[data-project-tags*="' + currentCategory + '"]').each( function(i) 
		            { 
		            	currentProjectCount++;
		            	openStatus = $(this).data('project-status');
		            	if (openStatuses.indexOf(openStatus) === -1) 
		            	{
		            		openStatuses.push(openStatus);
		            	}		            	

		            	$(this).slideDown( 500 );

		            });

	            }
	            else if (currentStatus != '' && currentCategory == '')
	           	{
		            $('#projectListingsContent .project-row').each( function(i) 
		            { 
		            	openStatus = $(this).data('project-status');
		            	if (openStatus == currentStatus)
		            	{
		            		currentProjectCount++;
		            		$(this).slideDown( 500 );
		            	}		
		            });

		            openStatuses.push(currentStatus);
	           	} 
	           	else
	           	{
		            $('#projectListingsContent .project-row[data-project-tags*="' + currentCategory + '"]').each( function(i) 
		            { 
		            	openStatus = $(this).data('project-status');
		            	if (openStatus == currentStatus)
		            	{
		            		currentProjectCount++;
		            		$(this).slideDown( 500 );
		            	}		
		            });

		            openStatuses.push(currentStatus);
	           	}


	            if (openStatuses.length > 0 && currentProjectCount > 0)
	            {
					for (var i = 0; i < openStatuses.length; i++) 
					{
						$('#projectListingsContent .project-header[data-project-status="' + openStatuses[i] + '"]').slideDown(100); 
					}
					$('#noProjects').slideUp( 100 );
	            }



				// outputs
	            $('#projectCount').html(currentProjectCount);
	            if (currentProjectCount == 0)
	            {
	            	$('#noProjects').slideDown( 500 );
	            }

	       	}


        }


	}

    if ( $('#projectListingsContent').length )
    {
        projectListings();
    }

});
